import React, {memo, useCallback, MouseEvent} from "react"
import {onClickHandler} from "../../../../../utils/onclick"
import iconUpArrow from "../../../../../assets/images/icons/scenario/up-arrow.png"
import iconDownArrow from "../../../../../assets/images/icons/scenario/down-arrow.png"

type UpDownProps = {
    index: number
    onUpClick?: (index: number) => void
    onDownClick?: (index: number) => void
}

export const UpDown = memo(function UpDown({
    onUpClick: onUpClickProp,
    onDownClick: onDownClickProp,
    index
}: UpDownProps) {
    const onUpClick = useCallback(
        (e: MouseEvent<HTMLDivElement>) => {
            e.stopPropagation()
            onUpClickProp(index)
        },
        [onUpClickProp, index]
    )

    const onDownClick = useCallback(
        (e: MouseEvent<HTMLDivElement>) => {
            e.stopPropagation()
            onDownClickProp(index)
        },
        [onDownClickProp, index]
    )

    return (
        <div className="up-down-button-container">
            {renderIf(onUpClickProp)(
                () => (
                    <div className="up-down-button" {...onClickHandler(onUpClick)}>
                        <img src={iconUpArrow} alt="" />
                    </div>
                ),
                () => (
                    <div className="up-down-button" />
                )
            )}
            {renderIf(onDownClickProp)(() => (
                <div className="up-down-button" {...onClickHandler(onDownClick)}>
                    <img src={iconDownArrow} alt="" />
                </div>
            ))}
        </div>
    )
})
